import { MENTION_TOKEN_WITH_ID_PATTERN, createMentionPatternForPerson } from '@/helpers/assignPersonMention';

type Person = {
  id: string;
  name: string | null;
};

const replaceTaggedUsersInHtml = ({ message, taggedUsers }: { message: string; taggedUsers: Person[] }): string => {
  if (taggedUsers.length === 0) {
    return message;
  }
  const taggedUserIds: string[] = Array.from(message.matchAll(MENTION_TOKEN_WITH_ID_PATTERN), (match) => match[1]);
  let replacedMessage = message;
  taggedUsers.forEach((user) => {
    replacedMessage = replacedMessage.replace(
      createMentionPatternForPerson(user.id),
      `<span style="color: var(--color-noodle);">@${user.name || user.id}</span>`,
    );
  });
  taggedUserIds.forEach((id) => {
    if (!taggedUsers.find((u) => u.id === id)) {
      replacedMessage = replacedMessage.replace(
        createMentionPatternForPerson(id),
        '<span style="color: var(--color-noodle);">@{Deleted User}</span>',
      );
    }
  });
  return replacedMessage;
};

export default replaceTaggedUsersInHtml;
